

// import React, { useEffect, useState } from "react";
// import { Box, Typography, Link, Button, Grid, CircularProgress } from "@mui/material";

// import camera from "../../../src/assests/images/dicons.svg";
// import marker from "../../../src/assests/images/marker.svg";

// import { getToken } from "../../utils/utils";
// import { getPendingapprovedTasks, getTasks } from "../../pages/tasks/api";
// import PaginationComponent from "../AssignTask/Pagination";
// import { ispubishedchnages } from "../ActiveTask/api";

// type Point = {
//   id: string;
//   one: string;
//   two: string;
// };

// type ProductCardSection = {
//   id: string;
//   head: string;
//   subhead: string;
//   pdf: string;
//   marker: string;
//   points: Point[];
// };

// const productcardone: ProductCardSection[] = [
//   {
//     id: "1",
//     head: "Educational Task",
//     subhead: "Know our products",
//     pdf: camera,
//     marker: marker,
//     points: [
//       { id: "1", one: "Start Date :", two: "11 Nov 2024" },
//       { id: "2", one: "End Date :", two: "14 Nov 2024" },
//       { id: "3", one: "Points :", two: "300 pts" },
//     ],
//   },
// ];

// // const Productcard: React.FC = () => {

// interface ChildProps {
//   Totalcount: number;
//   setTotalcount: React.Dispatch<React.SetStateAction<number>>;

  

// }

// const Productcard: React.FC<ChildProps> = ({
//   Totalcount,
//   setTotalcount,
  

// }) => {
//   const [tasks, setTasks] = useState<ProductCardSection[]>([]);
//   const [taskEnString, setTaskEnString] = useState("");
//   const token = getToken();
//   const perpagedata = 10;


//   const [page, setPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(0);
//    const [Totalcountpending, setTotalcountpending] = useState(0);



//   const [loading, setLoading] = useState(false); // Loading state
//   useEffect(() => {
//     const fetchTasks = async () => {
//       try {
//         setLoading(true);
//         const response = await getPendingapprovedTasks(token, page, 10, "pending");

//         const paginatedResults = response.data.data.paginatedResults;

//         const mappedTasks = paginatedResults.map((task: any) => ({
//           id: task.task_id,
//           head: task.task_type_en,
//           subhead: task.task_en,
//           pdf: camera,
//           marker: marker,
//           points: [
//             { id: "1", one: "Points :", two: `${task.credit_points || 0} pts` },
//             {
//               id: "2",
//               one: "Duration :",
//               two: task.duration
//             },


//           ],
//         }));

//         const uniqueTaskEnValues = Array.from(
//           new Set(paginatedResults.map((task: any) => task.task_en))
//         );

//         setTaskEnString(uniqueTaskEnValues.join(" "));

//         setTimeout(() => {
//           setTasks(mappedTasks);

//         //   setactivecount(response.data.data.total_users)
//             setTotalcountpending(response.data.data.total_users); // assuming this is total task count
//           setLoading(false);
//         }, 2000);
//       } catch (error) {
//         console.error("Error fetching tasks:", error);
//       }
//     };

//     fetchTasks();
//   }, [token, page]);

//   useEffect(() => {
//     const fetchTasks = async () => {
//       try {
//         const response = await ispubishedchnages(token);


//       } catch (error) {
//         console.error("Error fetching tasks:", error);
//       }
//     };

//     fetchTasks();
//   }, [token]);

//   const totalPages1 = Math.ceil(Totalcountpending / perpagedata);
//   console.log(Totalcount, "Totalcountssssssssssssssss")
//   console.log(JSON.stringify(tasks, null, 2), "Response data");
//   console.log(tasks, "taskssss85965123333")
//   return (
//     <>
//       <Grid container spacing={2} sx={{ marginTop: "24px", padding: "0 32px" }}>
//         {loading ? (
//           <Box
//             sx={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               height: "200px", // Adjust height as needed
//               width: "100%", // Ensure it spans full width of Grid container
//             }}
//           >
//             <CircularProgress />
//           </Box>
//         ) : (
//           tasks.map((section) => (
//             <Grid
//               key={section.id}
//               item
//               md={6}
//               sx={{ paddingTop: "0 !important" }}
//             >
//               <Box
//                 sx={{
//                   background: "#FFFFFF",
//                   borderRadius: "14px",
//                   padding: "12px 14px !important",
//                   marginBottom: "16px",
//                 }}
//               >
//                 <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
//                   <Box
//                     sx={{
//                       background: "rgba(255, 235, 239, 0.5)",
//                       borderRadius: "6px",
//                       padding: "10px",
//                     }}
//                   >
//                     <img
//                       src={section.pdf}
//                       alt={"dsadas"}
//                       width={24}
//                       height={24}
//                     />
//                   </Box>
//                   <Box>
//                     <Typography
//                       variant="h6"
//                       sx={{
//                         fontSize: "14px",
//                         fontWeight: "400",
//                         color: "rgba(105, 106, 107, 1)",
//                       }}
//                     >
//                       {section.head}
//                     </Typography>
//                     <Typography
//                       variant="h6"
//                       sx={{ fontSize: "18px", fontWeight: "600" }}
//                     >
//                       {section.subhead}
//                     </Typography>
//                   </Box>
//                   <Button
//                     sx={{
//                       marginLeft: "auto",
//                       padding: "0",
//                       minWidth: "fit-content",
//                     }}
//                   >
//                     {/* <img
//                     src={section.marker}
//                     alt={"marker"}
//                     width={24}
//                     height={24}
//                   /> */}
//                   </Button>
//                 </Box>
//                 <Grid
//                   container
//                   spacing={0}
//                   sx={{
//                     margin: "16px 0",
//                     backgroundColor: "rgba(249, 251, 252, 1)",
//                     padding: "12px 12px 2px",
//                     borderRadius: "12px",
//                   }}
//                 >
//                   {section.points.map((item) => (
//                     <Grid
//                       key={item.id}
//                       item
//                       md={6}
//                       sx={{ padding: "0 !important" }}
//                     >
//                       <Box
//                         sx={{
//                           display: "flex",
//                           alignItems: "center",
//                           marginBottom: "10px",
//                         }}
//                       >
//                         <Typography
//                           variant="h6"
//                           sx={{
//                             fontSize: "16px",
//                             fontWeight: "500",
//                             color: "rgba(73, 74, 75, 1)",
//                           }}
//                         >
//                           {item.one}
//                         </Typography>
//                         <Typography
//                           variant="h6"
//                           sx={{ fontSize: "16px", fontWeight: "700" }}
//                         >
//                           {item.two}
//                         </Typography>
//                       </Box>
//                     </Grid>
//                   ))}
//                 </Grid>
//                 <Box
//                   sx={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: "16px",
//                     justifyContent: "space-between",
//                   }}
//                 >
//                   <Link
//                     sx={{
//                       border: "1px solid rgba(200, 23, 47, 1)",
//                       borderRadius: "8px",
//                       padding: "10px 70px",
//                       color: "rgba(200, 23, 47, 1)",
//                       textDecoration: "none",
//                       width: "50%",
//                       textAlign: "center",
//                       fontSize: "14px",
//                       fontWeight: "500",
//                     }}
//                     href={`/Admin_approval/${section.id}/${section.head}`}
//                     target="_blank"
//                     rel="noopener noreferrer"
//                   >
//                     Preview Task
//                   </Link>
//                   <Link
//                     href={`/manage-task/edit-task/${section.id}`}
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     sx={{
//                       border: "1px solid rgba(200, 23, 47, 1)",
//                       borderRadius: "8px",
//                       padding: "10px 70px",
//                       color: "#FFF",
//                       textDecoration: "none",
//                       background: "rgba(200, 23, 47, 1)",
//                       width: "50%",
//                       textAlign: "center",
//                       fontSize: "14px",
//                       fontWeight: "500",
//                     }}
//                   >
//                    Edit Task
//                   </Link>

//                 </Box>
//               </Box>
//             </Grid>
//           ))
//         )}

//       </Grid>
//       {tasks.length > 0 ? (
//         <Box
//           sx={{
//             background: "#fff",
//             border: "none",
//             borderTop: "1px solid rgba(224, 224, 224, 1)",
//             borderBottom: "1px solid rgba(224, 224, 224, 1)",
//             // margin: "0 32px",
//             margin: "0"
//           }}
//         >
//           <PaginationComponent
//             page={page}
//             limit={10}
//             totalPages={totalPages1}
//             setPage={setPage}
//           />
//         </Box>
//       ) : (
//         <Box
//           sx={{
//             background: "#fff",
//             border: "1px solid rgba(224, 224, 224, 1)",
//             borderTop: "none",
//             margin: "0 32px",
//             padding: "16px",
//             textAlign: "center",
//           }}
//         >
//           No data is available
//         </Box>
//       )}

//     </>
//   );
// };

// export default Productcard;
import React, { useEffect, useRef, useState } from "react";
import { Box, Typography, Link as MuiLink, Button, Grid, CircularProgress, InputAdornment, TextField, List, ListItemButton, ListItemText, Tooltip } from "@mui/material";
import { Card, CardContent } from "@mui/material"; // Added Card imports
import { Link, useNavigate } from "react-router-dom"; // Added react-router-dom Link import

import camera from "../../../src/assests/images/dicons.svg"; // Check path correctness
import marker from "../../../src/assests/images/marker.svg"; // Check path correctness
import Dublicate from "../../../src/assests/images/dublicate-icon.svg";
import sorterArrow from "../../../src/assests/images/SortingArrow.svg";
import { getToken } from "../../utils/utils";
import { getPendingapprovedTasks, getTasks } from "../../pages/tasks/api";
import PaginationComponent from "../AssignTask/Pagination";
import { ispubishedchnages } from "../ActiveTask/api";
import FrameIcon from "../../../src/assests/images/frameIcon.svg";
import SearchIcon from "@mui/icons-material/Search";

// import PaginationComponent from "../AssignTask/Pagination";

type Point = {
  id: string;
  one: string;
  two: string;
};

// Updated type to match JSX usage
type ProductCardSection = {
  is_approved_reqired: string;
  task_status: string;
  publish_status: string;
  end_date: string;
  start_date: string;
  total_accounts: string;
  record_type: string;
  task_id: string; // Changed from id to task_id
  taskTitle: string; // Added taskTitle
  title: string; // Added title
  tag: string; // Added tag
  credit_points: string; // Added credit_points
  createdAt: string; // Added createdAt
  task_type_en: string;
  task_en: string;
  pdf: string;
  marker: string;
  points: Point[];
};

interface ChildProps {
  Totalcount: number;
  setTotalcount: React.Dispatch<React.SetStateAction<number>>;
  type:string
   value: number;
   searchTermpending: string;
  setSearchTermpending: React.Dispatch<React.SetStateAction<string>>;
   searchTermRejected: string;
  setSearchTermRejected: React.Dispatch<React.SetStateAction<string>>;

  debouncedSearchPending: string;
  setDebouncedSearchPending: React.Dispatch<React.SetStateAction<string>>;
  debouncedSearchRejected: string;
  setDebouncedSearchRejected: React.Dispatch<React.SetStateAction<string>>;
    sortOption: "highest" | "lowest" | null;
  setSortOption: React.Dispatch<React.SetStateAction<"highest" | "lowest" | null>>;
}

const Productcard: React.FC<ChildProps> = ({ sortOption, setSortOption, Totalcount, setTotalcount ,type,value,searchTermpending,setSearchTermpending, searchTermRejected,
  setSearchTermRejected,debouncedSearchPending, setDebouncedSearchPending,debouncedSearchRejected, setDebouncedSearchRejected}) => {
  const [tasks, setTasks] = useState<ProductCardSection[]>([]);
  const [taskEnString, setTaskEnString] = useState("");
  
  // const [sortOption, setSortOption] = useState<"highest" | "lowest" | null>(null);
  const token = getToken();
    // const [searchTerm, setSearchTerm] = useState("");
   const navigate = useNavigate();
  const perpagedata = 10;
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0); // Fixed: Now used
  const [totalCountPending, setTotalCountPending] = useState(0); // Fixed naming convention
  const [loading, setLoading] = useState(false);
//   const [debouncedSearchPending, setDebouncedSearchPending] = useState(searchTermpending);
// const [debouncedSearchRejected, setDebouncedSearchRejected] = useState(searchTermRejected);

useEffect(() => {
  const handler = setTimeout(() => setDebouncedSearchPending(searchTermpending), 500);
  return () => clearTimeout(handler);
}, [searchTermpending]);

useEffect(() => {
  const handler = setTimeout(() => setDebouncedSearchRejected(searchTermRejected), 500);
  return () => clearTimeout(handler);
}, [searchTermRejected]);


 const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const suffix =
      day % 10 === 1 && day !== 11
        ? "st"
        : day % 10 === 2 && day !== 12
        ? "nd"
        : day % 10 === 3 && day !== 13
        ? "rd"
        : "th";
    const month = date.toLocaleString("en-US", { month: "short" });
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    return `${day}${suffix} ${month} ${year}, ${hours}:${minutes}`;
  };

   useEffect(() => {
  if (value !== 3 && value !== 4) return; // Only run for pending or rejected tabs

  const fetchTasks = async () => {
    try {
      setLoading(true);

      const type = value === 3 ? "pending" : "rejected"; // Explicitly define type
       const searchTerm = value === 3 ? debouncedSearchPending : debouncedSearchRejected;
      const response = await getPendingapprovedTasks(token, page, 10, type,searchTerm,sortOption?sortOption:'');

        const paginatedResults = response.data.data.paginatedResults;

        const mappedTasks = paginatedResults.map((task: any) => ({
          task_id: task.task_id,
          taskTitle: task.task_type_en, // Map to taskTitle
          title: task.task_en, // Map to title
          tag: task.tag || "Not Published", // Fallback for tag
          credit_points:task.credit_points || 0,
          createdAt:formatDate(task.createdAt), // Fallback for createdAt
          task_type_en: task.task_type_en,
          task_en: task.task_en,
          pdf: camera,
          marker: marker,
          points: [
            { id: "1", one: "Points :", two: `${task.credit_points || 0} pts` },
            { id: "2", one: "Duration :", two: task.duration || "N/A" },
          ],
          record_type:task.record_type,
            total_accounts:task.total_accounts,
            end_date:formatDate(task.end_date),
            start_date:formatDate(task.start_date),
            publish_status:task.publish_status,
            task_status:task.main_task_status,
            is_approved_reqired:task.is_approved_reqired
        }));

        const uniqueTaskEnValues = Array.from(
          new Set(paginatedResults.map((task: any) => task.task_en))
        );

        setTaskEnString(uniqueTaskEnValues.join(" "));
        setTasks(mappedTasks);
        setTotalCountPending(response.data.data.total_users);
        setTotalPages(Math.ceil(response.data.data.total_users / perpagedata)); // Set totalPages
        setLoading(false);
      } catch (error) {
        console.error("Error fetching tasks:", error);
        setLoading(false);
      }
    };

    fetchTasks();
  }, [token, page,value,debouncedSearchPending, debouncedSearchRejected,sortOption]);

  useEffect(() => {
    const fetchTasks = async () => {
      try {
        await ispubishedchnages(token);
      } catch (error) {
        console.error("Error fetching published changes:", error);
      }
    };

    fetchTasks();
  }, [token]);

  // Define handleLinkClick
  // const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
  //   e.stopPropagation(); // Prevent event bubbling if needed
  //   // Add any specific logic for link clicks if required
  // };

  const handleLinkClick = (e: React.MouseEvent) => {
  e.stopPropagation(); // ✅ prevents parent onClick (like a card) from firing
  setTimeout(() => {
    window.location.reload(); // ✅ reloads after 100ms
  }, 100);
};

  console.log({ Totalcount, tasks, taskEnString }); // Consolidated logging
const handleDuplicateClick = (
  e: React.MouseEvent,
  taskId: string
) => {
  e.stopPropagation(); // Prevent card click navigation
  navigate(`/manage-task/duplicate-task/${taskId}`); // ✅ use passed taskId
};


const sortButtonRef = useRef<HTMLButtonElement>(null);
const popupRef = useRef<HTMLDivElement>(null);
const [isPopupOpen, setIsPopupOpen] = useState(false);

console.log(sortOption, "sortOptionsortOption44444")
// Handle sort popup open/close
const handleSortButtonClick = () => setIsPopupOpen((prev) => !prev);

// Handle selection of sort option
const handleSortSelection = (option: "highest" | "lowest") => {
    setSortOption(option);
    setIsPopupOpen(false);
};



  return (
    <Box sx={{ padding: "0 32px" }}>


      <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "24px",
              }}
            >
              <TextField
                  required
                  placeholder={
                    Number(value) === 2
                      ? "Search by Task Name, Task Type"
                      : "Search by Task Name, Task Type"
                  }
                  sx={{
                    ".MuiOutlinedInput-root": {
                      borderRadius: "12px",
                      height: "48px",
                      width: "521px",
                      "@media (max-width:1366px)": {
                        width: "400px",
                      },
                    },
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}

                  value={value === 3 ? searchTermpending : searchTermRejected}
onChange={(e) => value === 3 ? setSearchTermpending(e.target.value) : setSearchTermRejected(e.target.value)}
           
                />
                
      
              {/* Sort Button */}
              <Box sx={{ position: "relative" }}>
                <Button
                  ref={sortButtonRef}
                  onClick={handleSortButtonClick}
                  variant="outlined"
                  sx={{
                    height: "48px",
                    borderRadius: "12px",
                    minWidth: "200px",
                    textTransform: "none",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  Sort By UpdateAt
                  <img
                    src={sorterArrow}
                    alt="Sort Arrow"
                    style={{ width: "16px", height: "16px" }}
                  />
                </Button>
      
                {isPopupOpen && (
                  <Box
                    ref={popupRef}
                    sx={{
                      position: "absolute",
                      top: "55px",
                      right: 0,
                      backgroundColor: "#fff",
                      border: "1px solid #ccc",
                      borderRadius: "8px",
                      zIndex: 999,
                      width: "200px",
                      boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                    }}
                  >
                    <List>
                      <ListItemButton onClick={() => handleSortSelection("highest")}>
                        <ListItemText primary="⬇️ Highest to Lowest" />
                      </ListItemButton>
                      <ListItemButton onClick={() => handleSortSelection("lowest")}>
                        <ListItemText primary="⬆️ Lowest to Highest" />
                      </ListItemButton>
                    </List>
                  </Box>
                )}
              </Box>
            </Box>



      
    
      <Grid container spacing={2} sx={{ marginTop: "24px" }}>
        {loading ? (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "200px",
              width: "100%",
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          tasks.map((task) => (
            <Grid key={task.task_id} item xs={12} sm={6} md={4}>
              <Card
                sx={{
                  maxWidth: "100%",
                  margin: 0,
                  border: "1px solid rgba(0, 0, 0, 0.12)",
                  boxShadow: "none",
                  borderRadius: "10px",
                  "&:hover": {
                    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)",
                  },
                  transition: "box-shadow 0.3s ease, transform 0.3s ease",
                  cursor: "pointer",
                 
                }}
              >
                <CardContent>
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    sx={{
                      borderBottom: "1px dashed #d0d0d0",
                      marginBottom: "10px",
                      paddingBottom: "10px",
                    }}
                  >
                    <Box>
                      {/* <Typography sx={{ color: "#696A6B", fontSize: "14px" }}>
                        {task.taskTitle}
                      </Typography>
                      <Typography
                        sx={{ fontSize: "18px", color: "#282829" }}
                        variant="h6"
                        fontWeight="bold"
                      >
                        {task.title}
                      </Typography> */}
                      <Typography
                                      sx={{ color: "#696A6B", fontSize: "14px", display: "flex" }}
                                    >
                                      <img src={FrameIcon} alt="FrameIcon" />
                                      <Typography sx={{ margin: "0px 10px" }}>
                                        {task.taskTitle}
                                       <Tooltip title={task.title} arrow>
  <Typography
    sx={{
      fontSize: "18px",
      color: "#282829",
      fontWeight: "bold",
      maxWidth: 150, // adjust width to your layout
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      cursor: "pointer",
      display: "block",
    }}
    variant="h6"
  >
    {task.title}
  </Typography>
</Tooltip>
                                      </Typography>
                                    </Typography>
                    </Box>

{(task.publish_status === "Not Published" || task.publish_status === "Published") && (
                    <Box>
                      <Typography
                        sx={{
                          fontSize: "12px",
                          color:
                           task.publish_status === "Not Published"
                              ? "#696A6B"
                              : "#2E844A",
                          background:
                             task.publish_status === "Not Published"
                              ? "#E3E3E3"
                              : "#EBF7E6",
                          padding: "7px 10px",
                          borderRadius: "10px",
                          fontWeight: "600",
                        }}
                      >
                        {task.publish_status}
                      </Typography>
                    </Box>
)}
{task.is_approved_reqired === "rejected" && (

 <Box>
              <img
                src={Dublicate}
                alt="Duplicate Icon"
                style={{ cursor: "pointer", width: "23px" }}
                 onClick={(e) => handleDuplicateClick(e, task.task_id)} // Use the navigation handler
              />
            </Box>

)}
                  </Box>

                  <Typography
                    variant="body1"
                    sx={{ color: "#696A6B", fontSize: "14px", marginBottom: "8px" }}
                  >
                     Credit Points: <b style={{ color: "#282829" }}>{task.credit_points}</b>
                  </Typography>
                    <Typography
                              variant="body1"
                              sx={{ color: "#696A6B", fontSize: "14px", marginBottom: "8px" }}
                            >
                              Created By: <b style={{ color: "#282829" }}>{"Admin"}</b>
                            </Typography>
                  <Typography
                    variant="body2"
                    sx={{ color: "#696A6B", fontSize: "14px", marginBottom: "8px" }}
                  >
                    Created At: <b style={{ color: "#282829" }}>{task.createdAt}</b>
                  </Typography>
                 
                    <Typography
                    variant="body2"
                    sx={{ color: "#696A6B", fontSize: "14px", marginBottom: "8px" }}
                  >
                    Task Status: <b style={{ color: "#282829" }}>
                 {task.record_type === "user_task_mapping" ? "rejected" : "pending"}
                      </b>
                  </Typography>
{task.record_type === "user_task_mapping" && (
   <>
                  <Typography
                    variant="body2"
                    sx={{ color: "#696A6B", fontSize: "14px", marginBottom: "8px" }}
                  >
                    Total Users: <b style={{ color: "#282829" }}>{task.total_accounts}</b>
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ color: "#696A6B", fontSize: "14px", marginBottom: "8px" }}
                  >
                    Assigned Date: <b style={{ color: "#282829" }}>{task.start_date}</b>
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ color: "#696A6B", fontSize: "14px", marginBottom: "8px" }}
                  >
                    End Date: <b style={{ color: "#282829" }}>{task.end_date}</b>
                  </Typography>
                  
  </>
)}
{task.is_approved_reqired === "rejected" && (
<Box
  sx={{
    display: "flex",
    alignItems: "center",
    gap: "16px",
    marginTop: "16px",
  }}
>
 
  {/* <Link
    to={`/manage-task/edit-task/${task.task_id}`}
    // target="_blank"
    rel="noopener noreferrer"
    style={{
      border: "1px solid rgba(200, 23, 47, 1)",
      borderRadius: "8px",
      padding: "6px 40px", // Reduced vertical padding to 6px, increased horizontal to 40px for wider buttons
      color: "#FFF",
      textDecoration: "none",
      background: "rgba(200, 23, 47, 1)",
      textAlign: "center",
      fontSize: "14px",
      fontWeight: "500",
      boxSizing: "border-box",
      lineHeight: "1.2", // Tighter vertical alignment for shorter height
      flex: 1, // Use flex to grow equally and handle alignment dynamically
    }}
    onClick={handleLinkClick}
  >
    Edit Task
  </Link> */}
</Box>
)}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "16px",
                      justifyContent: "space-between",
                      marginTop: "16px",
                    }}
                  >
                    <Link
                                         to={`/Admin_approval/${task.task_id}/Educational`}
                                         // target="_blank"
                                         rel="noopener noreferrer"
                                         style={{
                                           border: "1px solid rgba(200, 23, 47, 1)",
                                           borderRadius: "8px",
                                           padding: "6px 40px", // Reduced vertical padding to 6px, increased horizontal to 40px for wider buttons
                                           color: "rgba(200, 23, 47, 1)",
                                           textDecoration: "none",
                                           textAlign: "center",
                                           fontSize: "14px",
                                           fontWeight: "500",
                                           boxSizing: "border-box",
                                           lineHeight: "1.2", // Tighter vertical alignment for shorter height
                                           flex: 1, // Use flex to grow equally and handle alignment dynamically
                                         }}
                                         onClick={handleLinkClick}
                                       >
                                         Preview Task
                                       </Link>
                     <Link
                                          to={`/manage-task/edit-task/${task.task_id}`}
                                          // target="_blank"
                                          rel="noopener noreferrer"
                                          style={{
                                            border: "1px solid rgba(200, 23, 47, 1)",
                                            borderRadius: "8px",
                                            padding: "6px 40px", // Reduced vertical padding to 6px, increased horizontal to 40px for wider buttons
                                            color: "#FFF",
                                            textDecoration: "none",
                                            background: "rgba(200, 23, 47, 1)",
                                            textAlign: "center",
                                            fontSize: "14px",
                                            fontWeight: "500",
                                            boxSizing: "border-box",
                                            lineHeight: "1.2", // Tighter vertical alignment for shorter height
                                            flex: 1, // Use flex to grow equally and handle alignment dynamically
                                          }}
                                          onClick={handleLinkClick}
                                        >
                                          Edit Task
                                        </Link>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))
        )}
      </Grid>

      {tasks.length > 0 && type==="" && (
        <Box sx={{ background: "#fff", margin: "0" }}>
          <PaginationComponent
            page={page}
            limit={perpagedata}
            totalPages={totalPages} // Use state variable
            setPage={setPage}
          />
        </Box>
      )}

      {tasks.length === 0 && !loading && (
        <Box
          sx={{
            background: "#fff",
            border: "1px solid rgba(224, 224, 224, 1)",
            borderTop: "none",
            margin: "0 32px",
            padding: "16px",
            textAlign: "center",
          }}
        >
          No data is available
        </Box>
      )}
    </Box>
  );
};

export default Productcard;